export const USER_ROUTES_IDS = {
  AUSWERTUNGEN: 'auswertungen',
  // User-App Sidebar-Navigation
  USER_COMPLIANCE_OVERVIEW: 'user-compliance-overview',
  USER_TASKS: 'user-tasks',
  USER_REPORTS_ANALYSIS: 'user-reports-analysis',
  USER_REPORTS_LOCATION_COMPARISON: 'user-reports-location-comparison',
  USER_ADMINISTRATION_USER_MANAGEMENT: 'user-administration-user-management',
  USER_ADMINISTRATION_USER_MANAGEMENT_BENUTZER: 'user-administration-user-management-benutzer',
  USER_ADMINISTRATION_USER_MANAGEMENT_BERECHTIGUNGEN: 'user-administration-user-management-berechtigungen',
  USER_ADMINISTRATION_USER_MANAGEMENT_EINSTELLUNGEN: 'user-administration-user-management-einstellungen',
  USER_ADMINISTRATION_LEXPLUS_CONFIG: 'user-administration-lexplus-config',
  USER_ADMINISTRATION_LEXPLUS_CONFIG_FUNKTIONEN: 'user-administration-lexplus-config-funktionen',
  USER_ADMINISTRATION_LEXPLUS_CONFIG_THEMENBEREICHE: 'user-administration-lexplus-config-themenbereiche',
  USER_ADMINISTRATION_LEXPLUS_CONFIG_STANDORTVERWALTUNG: 'user-administration-lexplus-config-standortverwaltung',
  USER_ADMINISTRATION_LEXPLUS_CONFIG_ANFORDERUNGEN_ANZEIGEFELDER: 'user-administration-lexplus-config-anforderungen-anzeigefelder',
  USER_ADMINISTRATION_LEXPLUS_CONFIG_EINSTELLUNGEN: 'user-administration-lexplus-config-einstellungen',
  USER_DOCUMENT_MANAGER: 'user-document-manager',
  USER_DOWNLOADS: 'user-downloads',
  USER_DOWNLOADS_GESETZESLISTEN: 'user-downloads-gesetzeslisten',
  USER_DOWNLOADS_NEWSLETTER: 'user-downloads-newsletter',
  USER_DOWNLOADS_NEWSLETTER_DETAIL: 'user-downloads-newsletter-detail',
  USER_DOWNLOADS_BERICHTE: 'user-downloads-begehungsberichte',
  USER_DOWNLOADS_AUTOMATISIERTE_BERICHTE: 'user-downloads-automatisierte-berichte',
  USER_FAQ: 'user-faq',
  DETAILS: 'details',
  // Segments of the detail drawer's levels that no page of their own is named after.
  ANFORDERUNGEN: 'anforderungen',
  ARCHIVIERTE_ANFORDERUNGEN: 'archivierte-anforderungen',
  INDIVIDUELLE_ANFORDERUNGEN: 'individuelle-anforderungen',
  ERLASSE: 'erlasse',
  FUNKTIONSZUWEISUNG: 'funktionszuweisung',
} as const;

export const LOCALIZED_USER_ROUTES: Record<string, Record<string, string>> = {
  [USER_ROUTES_IDS.AUSWERTUNGEN]: {
    de: 'auswertungen',
    fr: 'evaluations',
    it: 'valutazioni',
    en: 'evaluations',
  },
  [USER_ROUTES_IDS.USER_COMPLIANCE_OVERVIEW]: {
    de: 'compliance-uebersicht',
    fr: 'apercu-conformite',
    it: 'panoramica-conformita',
    en: 'compliance-overview',
  },
  [USER_ROUTES_IDS.USER_TASKS]: {
    de: 'aufgaben',
    fr: 'taches',
    it: 'compiti',
    en: 'tasks',
  },
  [USER_ROUTES_IDS.DETAILS]: {
    de: 'details',
    fr: 'details',
    it: 'dettagli',
    en: 'details',
  },
  [USER_ROUTES_IDS.ANFORDERUNGEN]: {
    de: 'anforderungen',
    fr: 'exigences',
    it: 'requisiti',
    en: 'requirements',
  },
  [USER_ROUTES_IDS.ARCHIVIERTE_ANFORDERUNGEN]: {
    de: 'archivierte-anforderungen',
    fr: 'exigences-archivees',
    it: 'requisiti-archiviati',
    en: 'archived-requirements',
  },
  [USER_ROUTES_IDS.INDIVIDUELLE_ANFORDERUNGEN]: {
    de: 'individuelle-anforderungen',
    fr: 'exigences-individuelles',
    it: 'requisiti-individuali',
    en: 'individual-requirements',
  },
  [USER_ROUTES_IDS.ERLASSE]: {
    de: 'erlasse',
    fr: 'actes',
    it: 'atti',
    en: 'regulations',
  },
  [USER_ROUTES_IDS.USER_REPORTS_ANALYSIS]: {
    de: 'auswertung',
    fr: 'analyse',
    it: 'analisi',
    en: 'analysis',
  },
  [USER_ROUTES_IDS.USER_REPORTS_LOCATION_COMPARISON]: {
    de: 'standortvergleich',
    fr: 'comparaison-sites',
    it: 'confronto-sedi',
    en: 'location-comparison',
  },
  [USER_ROUTES_IDS.USER_ADMINISTRATION_USER_MANAGEMENT]: {
    de: 'benutzerverwaltung',
    fr: 'gestion-utilisateurs',
    it: 'gestione-utenti',
    en: 'user-management',
  },
  [USER_ROUTES_IDS.USER_ADMINISTRATION_USER_MANAGEMENT_BENUTZER]: {
    de: 'benutzer',
    fr: 'utilisateurs',
    it: 'utenti',
    en: 'users',
  },
  [USER_ROUTES_IDS.USER_ADMINISTRATION_USER_MANAGEMENT_BERECHTIGUNGEN]: {
    de: 'berechtigungen',
    fr: 'autorisations',
    it: 'autorizzazioni',
    en: 'permissions',
  },
  [USER_ROUTES_IDS.USER_ADMINISTRATION_USER_MANAGEMENT_EINSTELLUNGEN]: {
    de: 'einstellungen',
    fr: 'parametres',
    it: 'impostazioni',
    en: 'settings',
  },
  [USER_ROUTES_IDS.USER_ADMINISTRATION_LEXPLUS_CONFIG]: {
    de: 'lexplus-konfiguration',
    fr: 'configuration-lexplus',
    it: 'configurazione-lexplus',
    en: 'lexplus-configuration',
  },
  [USER_ROUTES_IDS.USER_ADMINISTRATION_LEXPLUS_CONFIG_FUNKTIONEN]: {
    de: 'funktionen',
    fr: 'fonctionnalites',
    it: 'funzionalita',
    en: 'functions',
  },
  [USER_ROUTES_IDS.USER_ADMINISTRATION_LEXPLUS_CONFIG_THEMENBEREICHE]: {
    de: 'themenbereiche',
    fr: 'domaines-thematiques',
    it: 'temi',
    en: 'topics-areas',
  },
  [USER_ROUTES_IDS.USER_ADMINISTRATION_LEXPLUS_CONFIG_STANDORTVERWALTUNG]: {
    de: 'standortverwaltung',
    fr: 'gestion-localisation',
    it: 'gestione-ubicazione',
    en: 'location-management',
  },
  [USER_ROUTES_IDS.FUNKTIONSZUWEISUNG]: {
    de: 'funktionszuweisung',
    fr: 'attribution-fonction',
    it: 'assegnazione-funzione',
    en: 'function-assignment',
  },
  [USER_ROUTES_IDS.USER_ADMINISTRATION_LEXPLUS_CONFIG_ANFORDERUNGEN_ANZEIGEFELDER]: {
    de: 'anforderungen-anzeigefelder',
    fr: 'champs-affichage-exigences',
    it: 'campi-visualizzazione-requisiti',
    en: 'requirements-display-fields',
  },
  [USER_ROUTES_IDS.USER_ADMINISTRATION_LEXPLUS_CONFIG_EINSTELLUNGEN]: {
    de: 'einstellungen',
    fr: 'parametres',
    it: 'impostazioni',
    en: 'settings',
  },
  [USER_ROUTES_IDS.USER_DOCUMENT_MANAGER]: {
    de: 'dokumenten-manager',
    fr: 'gestionnaire-documents',
    it: 'gestione-documenti',
    en: 'document-manager',
  },
  [USER_ROUTES_IDS.USER_DOWNLOADS]: {
    de: 'downloads',
    fr: 'telechargements',
    it: 'download',
    en: 'downloads',
  },
  [USER_ROUTES_IDS.USER_DOWNLOADS_GESETZESLISTEN]: {
    de: 'gesetzeslisten',
    fr: 'listes-lois',
    it: 'elenchi-leggi',
    en: 'legal-lists',
  },
  [USER_ROUTES_IDS.USER_DOWNLOADS_NEWSLETTER]: {
    de: 'newsletter',
    fr: 'newsletter',
    it: 'newsletter',
    en: 'newsletter',
  },
  [USER_ROUTES_IDS.USER_DOWNLOADS_BERICHTE]: {
    de: 'berichte',
    fr: 'rapports',
    it: 'rapporti',
    en: 'reports',
  },
  [USER_ROUTES_IDS.USER_DOWNLOADS_AUTOMATISIERTE_BERICHTE]: {
    de: 'automatisierte-berichte',
    fr: 'rapports-automatises',
    it: 'rapporti-automatizzati',
    en: 'automated-reports',
  },
  [USER_ROUTES_IDS.USER_FAQ]: {
    de: 'faq',
    fr: 'faq',
    it: 'faq',
    en: 'faq',
  },
};
